import { render, staticRenderFns } from "./EditorPropertiesRow.vue?vue&type=template&id=37411abd&scoped=true&"
import script from "./EditorPropertiesRow.vue?vue&type=script&lang=js&"
export * from "./EditorPropertiesRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37411abd",
  null
  
)

export default component.exports